

export function createCheckboxCm ({newValue, newText, nameInput, parentId}) {
  const element = `
    <fieldset>
      <label class="cbCustom2">
      <input type="checkbox" name="${nameInput}" value="${newValue}"><span class="checkmark" data-parentid="${parentId}" data-value="2" data-name="${nameInput}"></span>
      <p>${newText}</p>
      </label>
    </fieldset>
  `
  return element
}